import cleanDeep from 'clean-deep';
import { NotificationManager } from 'react-notifications';
import apiURL from'./apiURL';
import { checkExecutionStatus, createRequest, pdfRequest } from '@/helpers/RequestHelpers';
// const apiURL = `http://localhost:3000`;

const paymentRequest = createRequest({
  urlPath: "/payment",
});

// types of action
const Types = {
  STRIPE_LIST: "PAYMENT_STRIPE_LIST",
  STRIPE_INTENT: "PAYMENT_STRIPE_INTENT",
  STRIPE_PAYMENT_METHODS: "PAYMENT_STRIPE_PAYMENT_METHODS",
  STRIPE_CREATE_CUSTOMER: "PAYMENT_STRIPE_CREATE_CUSTOMER",
  PAYMENT_GET_STATS: "PAYMENT_GET_STATS",
  PAYMENT_GET_BUNDLES: "PAYMENT_GET_BUNDLES",
  PAYMENT_MODAL: "PAYMENT_MODAL",
  PAYMENT_SELECT_BUNDLE: "PAYMENT_SELECT_BUNDLE",
  STRIPE_CREATE_CHARGE: "PAYMENT_STRIPE_CREATE_CHARGE",
  STRIPE_PROCESSING_CHARGE: "PAYMENT_STRIPE_PROCESSING_CHARGE",
  PAYMENT_STRIPE_ADD_NEW_CARD: "PAYMENT_STRIPE_ADD_NEW_CARD",
  PAYMENT_STRIPE_SAVING_CARD: "PAYMENT_STRIPE_SAVING_CARD",
  PAYMENT_GET_CREDITS: "PAYMENT_GET_CREDITS",
  PAYMENT_ADVISOR_CREDITS: "PAYMENT_ADVISOR_CREDITS",
  PAYMENT_DOWNLOADING: "PAYMENT_DOWNLOADING",
  PAYMENT_ADMIN_SERVICE_LIST: "PAYMENT_ADMIN_SERVICE_LIST",
  PAYMENT_SUCCESS_NOTIFICATION: "PAYMENT_SUCCESS_NOTIFICATION",
  PAYMENT_ERROR_NOTIFICATION: "PAYMENT_ERROR_NOTIFICATION",
  PAYMENT_SHOW_STRIPE_DELETE_MODAL: "PAYMENT_SHOW_STRIPE_DELETE_MODAL",
  PAYMENT_REMOVE_STRIPE: "PAYMENT_REMOVE_STRIPE",
  PAYMENT_SELECT_CREDIT: "PAYMENT_SELECT_CREDIT",
  PAYMENT_TRANSACTION_HISTORY: "PAYMENT_TRANSACTION_HISTORY",
  PAYMENT_TRANSACTION_HISTORY_MODAL: "PAYMENT_TRANSACTION_HISTORY_MODAL",
};

const addNewCard = status => ({
  type: Types.PAYMENT_STRIPE_ADD_NEW_CARD,
  status
});

const successNotification = message => ({
  type: Types.PAYMENT_SUCCESS_NOTIFICATION,
  message
})

const errorNotification = message => ({
  type: Types.PAYMENT_ERROR_NOTIFICATION,
  message
})

const savingNewCard = status => ({
  type: Types.PAYMENT_STRIPE_SAVING_CARD,
  status
});

const adminServices = response => ({
  type: Types.PAYMENT_ADMIN_SERVICE_LIST,
  response
})

const selectBundle = bundle => ({
  type: Types.PAYMENT_SELECT_BUNDLE,
  bundle
});

const showPricingModal = (status, isNew) => ({
  type: Types.PAYMENT_MODAL,
  status,
  isNew
});

const paymentBundles = response => ({
  type: Types.PAYMENT_GET_BUNDLES,
  payload: response
});

const showStripeDeleteModal = (status, id) => ({
  type: Types.PAYMENT_SHOW_STRIPE_DELETE_MODAL,
  status,
  id
})

const transferCredits = ({ toID, quantity, description }) => {
  return (dispatch, getState) => {
    const state = getState()

    fetch(apiURL + '/payment/transferCredits', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        fromID: state?.company?.settings?.org,
        toID,
        quantity,
        description
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          dispatch(getCredits({}))
          dispatch(successNotification('Your Credits have been Transferred Successfully!'))
          dispatch(getPaymentStats())
        }
      })
  }
}

/**
 * Transfer Credits to Advisor
 * @param toID
 * @param quantity
 * @param description
 * @returns {(function(*, *): void)|*}
 */
const transferCreditsToAdvisor = () => {
  return (dispatch, getState) => {
    const state = getState()

    const credits = state?.payment?.credits?.filter(c => c.selected).map(c => c.id)

    fetch(apiURL + '/payment/transferCreditsToAdvisor', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        credits
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          dispatch(getCredits({}))
          dispatch(successNotification('Your Credits have been Transferred Successfully!'))
        }
      })
  }
}

/**
 * Void Credits
 * @param toID
 * @param quantity
 * @param description
 * @returns {(function(*, *): void)|*}
 */
const voidCredits = () => {
  return (dispatch, getState) => {
    const state = getState()

    const credits = state?.payment?.credits?.filter(c => c.selected).map(c => c.id)

    fetch(apiURL + '/payment/void', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        credits
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          dispatch(getCredits({}))
          dispatch(successNotification('Your Credits have been Voided Successfully!'))
        }
      })
  }
}

const voidAdvisorCredits = () => {
  return (dispatch, getState) => {
    const state = getState()

    const credits = state?.advisor?.credits?.filter(c => c.selected).map(c => c.id)
    const advisorID = state?.my?.profile?.advisorId

    fetch(apiURL + '/payment/advisorVoid', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        credits,
        advisorID
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          dispatch(getAdvisorCredits({}))
          dispatch(successNotification('Your Credits have been Voided Successfully!'))
        }
      })
  }
}

const issueCredits = ({ invoiceNo, issueInvoice, bundleID, quantity, description }) => {
  return async (dispatch, getState) => {
    const state = getState()

    const { paidByAdvisor, advisor: advisorID, org: organisationID } = { ...state?.company?.settings }

    const body = {
      invoiceNo,
      issueInvoice,
      bundleID,
      quantity,
      description,
    }

    if (paidByAdvisor) {
      body.advisorID = advisorID
    } else {
      body.organisationID = organisationID
    }

    await fetch(apiURL + '/payment/issueInvoice', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          dispatch(getCredits({}))
          dispatch(successNotification('Your Credits have been issued Successfully!'))
          dispatch(getPaymentStats())
        }
        if (response.error) {
          dispatch(errorNotification(response.error))
        }
      })

  }
}

const issueTransaction = ({ amount, description, serviceID }) => {
  return async (dispatch, getState) => {
    const state = getState()

    const { paidByAdvisor, advisor: advisorID, org: organisationID } = { ...state?.company?.settings }

    const body = {
      serviceID,
      amount,
      description,
    }

    if (paidByAdvisor) {
      body.advisorID = advisorID
    } else {
      body.organisationID = organisationID
    }

    await fetch(apiURL + '/payment/issueTransaction', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) dispatch(successNotification('Your Transaction has been added Successfully!'))
      })
      .catch(error => {
        console.error(error)
        NotificationManager.error('Error Saving Transaction', 'Saving Transactions')
      })
    dispatch(getCredits({}))
    dispatch(getPaymentStats())

  }
}

const getServices = () => {
  return (dispatch, getState) => {
    fetch(apiURL + `/payment/services/list`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        dispatch(adminServices(data))
      })
  }
}

const getBundles = () => {

  return (dispatch, getState) => {

    fetch(apiURL + `/payment/bundles`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(paymentBundles(data))
      })

  }
};

const paymentStats = response => ({
  type: Types.PAYMENT_GET_STATS,
  payload: response,
  fetchingStats: false
});

const getPaymentStats = (id) => {

  return (dispatch, getState) => {

    const paymentState = getState().payment
    const fetchingStats = paymentState.fetchingStats

    if (fetchingStats && id && paymentState.id !== id) {
      // if passed an ID assume it needs to take over
      paymentState.controller.abort()
    } else if (fetchingStats) {
      // otherwise there's likely already a request in progress which should be fine
      return
    }

    const controller = new AbortController()


    dispatch({
        type: Types.PAYMENT_GET_STATS,
        fetchingStats: true,
        controller,
        id
    })

    // if an id is passed us it as it will override the default current org (eg get advisor)
    fetch(apiURL + `/payment/stats${id ? `/${id}` : ``}`, {
      credentials: 'include',
      method: 'GET',
      signal: controller.signal,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(paymentStats(data))
      })
      .catch(error => {
          console.error(error)
        dispatch({
            type: Types.PAYMENT_GET_STATS,
            fetchingStats: false,
        })
      })

  }
};

const creditStats = response => ({
  type: Types.PAYMENT_GET_CREDITS,
  payload: response
});

const advisorCreditStats = response => ({
  type: Types.PAYMENT_ADVISOR_CREDITS,
  payload: response
})

const getCredits = ({ before, after }) => {

  return (dispatch, getState) => {

    fetch(apiURL + `/settings/credits`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        before,
        after
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(creditStats(data))
      })

  }
};

const getAdvisorCredits = ({ before, after }) => {

  return (dispatch, getState) => {

    const qs = new URLSearchParams(cleanDeep({ before, after })).toString();
    console.log("ADVISORRRRRRRRRRRRRRRRRRR", qs)
    fetch(apiURL + `/settings/advisor/credits${qs}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(advisorCreditStats(data?.credits))
      })

  }
};

const downloadReportStatus = (index, processing) => ({
  type: Types.PAYMENT_DOWNLOADING,
  index,
  processing
});

const checkInvoiceStatus = (arn, index) => {
  return (dispatch, getState) => {
    fetch(apiURL + `/settings/describe-execution/${arn}`, {
      credentials: "include",
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then(data => {

        const finished = data.data.status != "RUNNING"

        if (finished) {
          if (data.data.status == 'SUCCEEDED') {

            console.log("dataaaaaa", data.data)
            const output = JSON.parse(data.data.output);

            let popup;
            popup = window.open(output.url);
            if (!popup || popup.closed || typeof popup.closed == 'undefined') {
              alert('Popup Blocker is enabled! Please add this site to your exception list.');
            }
            dispatch(downloadReportStatus(index, false))
          }
        } else {
          setTimeout(() => dispatch(checkInvoiceStatus(arn)), 1000)
        }
      });
  }
};

const downloadInvoice = (creditId) => {
  return (dispatch, getState) => {
    fetch(apiURL + `/settings/invoice/generatePdf`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        creditId
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {

        if (data.url) {
          let popup;
          popup = window.open(data.url);
          if (!popup || popup.closed || typeof popup.closed == 'undefined') {
            alert('Popup Blocker is enabled! Please add this site to your exception list.');
          }
        } else if (data.executionArn) {
          const arn = data.executionArn;

          setTimeout(() => dispatch(checkInvoiceStatus(arn)), 1000)
        } else {
          NotificationManager.error("We encountered an issue in downloading your invoice.", "Error");
        }
      })
  }
}

const stripeIntent = response => ({
  type: Types.STRIPE_INTENT,
  payload: response
});

const getStripeIntent = (advisorCharge) => {

  return (dispatch, getState) => {

    const state = getState()

    const stripeCustomerID = state.payment.stats?.stripeCustomerID

    if (stripeCustomerID) {
      fetch(apiURL + `/payment/stripe/intent?advisor=${advisorCharge ? '1' : '0'}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
      })
        .then(response => response.json())
        .then(data => {
          dispatch(stripeIntent(data))
        })

    }
  }
};

const stripePaymentMethods = response => ({
  type: Types.STRIPE_PAYMENT_METHODS,
  payload: response
});

const getStripePaymentMethods = (id,advisorCharge) => {

  return (dispatch, getState) => {

    const state = getState()

    const stripeCustomerID = id ?? state.payment?.stats?.stripeCustomerID
    // console.log('stripeCustomerID', new Date(), stripeCustomerID)
    // customerID=${stripeCustomerID}&

    fetch(apiURL + `/payment/stripe/paymentMethods?advisor=${advisorCharge ? '1' : '0'}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(stripePaymentMethods(data))
      })
  }
};

const stripeCreateCustomer = response => ({
  type: Types.STRIPE_CREATE_CUSTOMER,
  payload: response
});

const createStripeCustomer = () => {
  console.log('inside createStripeCustomer')

  return (dispatch, getState) => {

    const state = getState()

    const stripeCustomerID = state.payment.stats?.stripeCustomerID

    const businessDetails = state.payment.stats?.businessDetails
    const name = businessDetails?.name || businessDetails?.companyName
    const email = businessDetails?.email
    const id = businessDetails?.id ?? businessDetails?.org

    if (!stripeCustomerID) {
      fetch(apiURL + `/payment/stripe/createCustomer${id ? `/${id}` : ``}`, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          name,
          email
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
      })
        .then(response => response.json())
        .then(data => {
          dispatch(stripeCreateCustomer(data))
          // get payment methods from new customer id
          dispatch(getStripePaymentMethods(data.id))
        })
    }
  }
};

const stripeProcessingCharge = () => ({
  type: Types.STRIPE_PROCESSING_CHARGE,
});

const stripeCharge = response => ({
  type: Types.STRIPE_CREATE_CHARGE,
  payload: response
});

const payNow = (paymentMethodID,advisorCharge) => {
   return (dispatch, getState) => {

     dispatch(stripeProcessingCharge())

     const state = getState()
     fetch(apiURL + `/payment/stripe/payBalance?advisor=${advisorCharge ? '1' : '0'}`, {
       credentials: 'include',
       method: 'POST',
       body: JSON.stringify({}),
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
         /*'Organisation': getState().currentOrganisation,*/
       },
     })
         .then(response => response.json())
         .then(data => {

           if (data.error){
             // show notification with error message
             NotificationManager.error(data.error,'Unable to Process Payment', 10000)
           }

           dispatch(stripeCharge(data))

           // if (data.paymentIntent.status == "succeeded") {
           dispatch(getPaymentStats())
           // }
         })
   }
}

const createStripeCharge = (paymentMethodID,advisorCharge) => {
  console.log('inside createStripeCustomer')

  return (dispatch, getState) => {

    dispatch(stripeProcessingCharge())

    const state = getState()

    const stripeCustomerID = state.payment.stats?.stripeCustomerID
    const bundleID = state.payment.selectedBundle.id

    const toSend = {
      paymentMethodID,
      bundleID,
      quantity: state.payment.selectedBundle.quantity || 1
    }

    const stats = state.payment.stats
    const isNew = state.payment.isNew
    const isDemo = stats && stats.businessDetails && stats.businessDetails?.companyName && stats.businessDetails?.companyName == "Demo Company"

    if (isDemo || isNew) {
      //toSend.isNew = true,
      toSend.organisationName = state.createAccount.data.organisation
      toSend.orgData = state.createAccount.data
      toSend.isNew = true
    }

    // if advisor includes advisorID
    if (advisorCharge && state.my.profile.isAdvisor) {
        toSend.advisorId = state.my.profile.advisorId
    }

    // if (stripeCustomerID){
    fetch(apiURL + `/payment/stripe/charge`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(toSend),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeCharge(data))

        if (data.paymentIntent.status == "succeeded") {
          dispatch(getPaymentStats())
        }
      })
    // }
  }
};

const processStripeCharge = (paymentIntentID) => {
  console.log('inside createStripeCustomer')

  return (dispatch, getState) => {

    dispatch(stripeProcessingCharge())

    const state = getState()

    fetch(apiURL + `/payment/stripe/process`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        paymentIntentID,
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeCharge(data))

        if (data.paymentIntent.status == "succeeded") {
          dispatch(getPaymentStats())
        }
      })
  }
};

const getStripePublicIntent = () => {

  return (dispatch, getState) => {

    const state = getState()

    fetch(apiURL + `/payment/stripe/publicIntent`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeIntent(data))
      })

  }
};

const deleteStripe = (id) => {

  return (dispatch, getState) => {
    const state = getState()

    fetch(apiURL + '/payment/stripe/paymentMethod/' + id, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(removeStripe(data))
      })
  }
}

const removeStripe = response => ({
  type: Types.PAYMENT_REMOVE_STRIPE,
  payload: response,
})

const selectCredit = (creditId) => ({
  type: Types.PAYMENT_SELECT_CREDIT,
  creditId,
})

const processTransactionHistory = (transactionHistory) => ({
  type: Types.PAYMENT_TRANSACTION_HISTORY,
  transactionHistory,
})

const getTransactionHistory = (transactionId) => {

  return async (dispatch, getState) => {

    await paymentRequest({
      path: `/transactionHistory/${transactionId}`,
      method: "GET"
    })
      .then(({data}) => {
        dispatch(processTransactionHistory(data))
    }).catch(error => {
      console.error(error)
      NotificationManager.error('Error Fetching Transaction History', 'Transaction History')
    })
  }
}

const toggleTransactionHistoryModal = (status, transaction) => ({
  type: Types.PAYMENT_TRANSACTION_HISTORY_MODAL,
  status,
  transaction
})

const downloadTransactionHistoryPDF = (creditId) => {
  return async (dispatch, getState) => {
    let arn;

    await pdfRequest({
      method: "POST",
      path: `/SingleTransactionHistory`,
      body: { creditId }
    })
    .then((data) => {
      console.debug(data);
      NotificationManager.success("PDF Saved, attemping download...", "Saving PDF");
			arn = data.data.executionArn;
    })
    .catch((error) => {
      console.error(error);
      NotificationManager.error("Error saving PDF", "Saving PDF");
    });

    if (arn) {
      await checkExecutionStatus(arn)
      .then((body) => {
        NotificationManager.success("PDF downloaded successfully", "Downloading PDF");
					const data = body.output;

          const popup = window.open(data.url);
          if (!popup || popup.closed || typeof popup.closed == "undefined") {
            //Worked For IE and Firefox
            alert("Popup Blocker is enabled! Please add this site to your exception list.");
          }
				})
				.catch((error) => {
          console.error(error);
					NotificationManager.error("Failed to download PDF", "Downloading PDF");
			});
    }
  }
}

const Actions = {
  getPaymentStats,
  getBundles,
  createStripeCustomer,
  getStripeIntent,
  getStripePublicIntent,
  getStripePaymentMethods,
  showPricingModal,
  selectBundle,
  createStripeCharge,
  getAdvisorCredits,
  addNewCard,
  savingNewCard,
  payNow,
  getCredits,
  downloadInvoice,
  processStripeCharge,
  transferCredits,
  transferCreditsToAdvisor,
  voidCredits,
  issueCredits,
  issueTransaction,
  getServices,
  showStripeDeleteModal,
  deleteStripe,
  selectCredit,
  voidAdvisorCredits,
  getTransactionHistory,
  toggleTransactionHistoryModal,
  downloadTransactionHistoryPDF,
};


export { Types, Actions }